/**
 * @prettier
 */

export const GROUP_LINK_SHARE_LIMIT_MESSAGE = "App link share limit exceeded.";

/**
 * True when group-link send returns HTTP 429 for share quota exhaustion.
 */
export function isGroupLinkShareLimitExceeded(error) {
    if (!error) {
        return false;
    }

    const data = error.response?.data;
    const message = data?.message;

    if (message === GROUP_LINK_SHARE_LIMIT_MESSAGE) {
        return true;
    }

    const status = Number(error.response?.status);
    return (
        status === 429 &&
        typeof message === "string" &&
        message.toLowerCase().includes("app link share limit")
    );
}
